import styled, { keyframes } from 'styled-components';
import Text from 'components/Text';

type ShowHistory = { showHistory: boolean; };
type ColumnProps = { width: string; redColor?: boolean; };
type CustomFlexTableProps = { noteLenght?: number; };

const charactersPerLineNoteRA = 60;

export const Container = styled.div`
  justify-content: center;
  align-items: center;
  margin: 10px 0 15px;
`;

export const InformativeNotePrice = styled.img`
  cursor: pointer;
  margin-right: 5px;
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;
`;

export const NoteSalePrice = styled.span`
  visibility: hidden;
  width: 160px;
  background-color: #ffffff;
  color: #364863;
  border: 1px solid #f2f3f4;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1000000;
  bottom: 70%;
  left: 450%;
  transform: translateX(-50%);

  ${Tooltip}:hover & {
    visibility: visible;
  }
`;

export const ButtonContainer = styled.div.attrs({
  role: "button"
})`
  justify-content: center;
  align-items: center;
  flex-direction: row;
  display: flex;
  gap: 10px;
  
  cursor: pointer;
  
  &:before, 
  &:after {
    content: "";
    width: 40%;
    height: 1px;
    left: 15px;
    position: absolute;
    background: rgba(133, 133, 133, 0.4);
  }
  
  &:after {
    left: inherit;
    right: 15px;    
  }
`;

export const ButtonHistory = styled(Text).attrs({
  className: "blue-gray font-bold"
})`
  align-items: center;
  justify-content: center;
  text-align: center;
  user-select: none;
`;

export const Img = styled.img<ShowHistory>`
  transform: ${props => !props.showHistory ? `rotate(0deg)` : `rotate(180deg)`};

  transition: transform .5s ease;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ContainerHistory = styled.div<ShowHistory>`
  min-width: 1326px;
  flex: 1;
  display: ${props => props.showHistory ? 'flex' : 'none'};
  flex-direction: row;
  justify-content: center;
  align-items: center;

  animation: ${fadeIn} .5s linear;
  transition: display .5s linear;

  margin: 10px 20px;
`;

export const TableHistory = styled.div`
  display: block;
`;

export const FlexTable = styled.div<CustomFlexTableProps>`
  gap: 18px;
  height: ${(props) => props?.noteLenght && props?.noteLenght > charactersPerLineNoteRA ? 
    `${props?.noteLenght / charactersPerLineNoteRA}em` : '15px'};
  display: flex;
  flex-flow: row wrap;

  margin-bottom: 10px !important;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Column = styled.div.attrs({
  className: "color-blue-gray font-bold"
}) <ColumnProps>`
  width: ${props => props.width};

  p {
    line-height: inherit;
    font-size: inherit !important;
  }
`;

export const Row = styled.div.attrs({
  className: "color-blue-gray"
}) <ColumnProps>`
  width: ${props => props.width};
  height: 15px;
  display: flex;
  align-items: center;

  .redLabel{
    color: ${props => props.redColor ? `#E02828` : ``};
  }

  p {
    line-height: inherit;
    font-size: inherit !important;
  }
`;

export const RowRA = styled.div<ColumnProps>`
  width: ${props => props.width};
  color: #BEBEBE;
  height: 15px;

  span {
    color: #AD36F5;
  }
`;

export const ContainerMoney = styled.div`
  display: flex;

  &:before {
    content: "";
    margin-right: 25px;
    border-left: 1px solid #D6D6D6;
  }
`;

export const ResponseMessage = styled.div`
  display: flex;
  flex-direction: row;
  height: 15px;

  &.deletedMessage{
    p{
      font-size: 13px !important;
    }

    img{
      height: 10px;
      margin-top: 4px;
    }
  }

  img{
    margin-right: 10px;
    width: 8px;
  }
`;

export const TableMoney = styled.div``;